import { useEffect, useState } from "react";

import remindmeStyles from "../flavours/remindme/remindme.module.scss";
import { useFlavour } from "../flavours/useFlavour";

export const useTheme = () => {
  const [styles, setStyles] = useState(remindmeStyles);
  const { isMedion, isFocus, isSfuchs } = useFlavour();
  useEffect(() => {
    let isMounted = true;

    if (isMedion) {
      import("../flavours/medion/medion.module.scss").then(module => {
        if (isMounted) setStyles(module.default);
      });
    } else if (isFocus) {
      import("../flavours/focus/focus.module.scss").then(module => {
        if (isMounted) setStyles(module.default);
      });
    } else if (isSfuchs) {
      import("../flavours/sfuchs/sfuchs.module.scss").then(module => {
        if (isMounted) setStyles(module.default);
      });
    }

    return () => {
      isMounted = false;
    };
  }, [isMedion, isFocus, isSfuchs]);

  return {
    styles,
    primaryColor: styles.primaryColor,
    fontColor: styles.fontColor,
    primaryColorHover: styles.primaryColorHover,
    primaryColorBorder: styles.primaryColorBorder,
    primaryColorBackground: styles.primaryBgColor,
    primaryButton: styles.primaryButton,
    secondaryButton: styles.secondaryButton,
    warningBackground: styles.warningBackground,
    error: styles.error,
    errorBorder: styles.errorBorder,
    warning: styles.warning,
    warningBorder: styles.warningBorder,
    navbar: {
      item: styles.navbarItem,
      subMenu: styles.navbarSubMenu,
    },
    link: styles.link,
  };
};
